/**
 * Utility for managing canonical URLs consistently across the site
 */

const BASE_URL = 'https://ad-email-lab.com';

/**
 * Generates a clean canonical URL for the current page
 * Removes query parameters and hash fragments to avoid duplicate content issues
 */
export const getCanonicalUrl = (path?: string): string => {
  if (path) {
    // Remove leading slash if present to avoid double slashes
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `${BASE_URL}/${cleanPath}`;
  }
  
  // Get current path without query params or hash
  const currentPath = window.location.pathname;
  return `${BASE_URL}${currentPath}`;
};

/**
 * Sets the canonical URL for the current page
 * Creates or updates the canonical link element in the document head
 */
export const setCanonicalUrl = (path?: string): void => {
  const canonicalUrl = getCanonicalUrl(path);
  
  let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.setAttribute('href', canonicalUrl);
};

/**
 * Updates or creates a meta tag with the specified name and content
 */
export const updateMeta = (name: string, content: string): void => {
  let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
};